import React from "react";
import { MdPauseCircleFilled, MdPlayCircleFilled } from "react-icons/md";
import { IconBaseProps } from "react-icons";

interface IProps {
  isPlaying: boolean
}

const commonProps: IconBaseProps = { display: "block", size: 60 };

export const ToggleIcon = ({ isPlaying }: IProps) => (isPlaying
  ? <MdPauseCircleFilled {...commonProps} />
  : <MdPlayCircleFilled {...commonProps} />
);
